import { DateRangePicker } from './DateRangePicker'
import type { SelectOption } from './Select'

type DateRangeButtonProps = {
  value: string
  options?: SelectOption<string>[]
  onChange: (rangeId: string) => void
  /** Trigger size; Payments uses the compact 33×130 control, Feedback uses 48×139. */
  height?: number
  width?: number
}

/**
 * Compact calendar trigger shared by Payments, Feedback, and Bookings toolbars.
 * Allows interactive date selection and shows the chosen date value dynamically.
 */
export const DateRangeButton = ({
  value,
  onChange,
  height = 33,
  width,
}: DateRangeButtonProps) => {
  return (
    <DateRangePicker
      value={value}
      onChange={(rangeId) => onChange(rangeId)}
      variant="button"
      height={height}
      width={width}
      label="Date range"
    />
  )
}
